import {isUnidentifiedRecipient} from 'shells/inbox/helpers';

import {ThreadType} from 'nutshell-graphql-types';

import {AUTO_DISTRIBUTE_OPTION} from '../../core/form/fields/consts';

import {useCreateLeadByThread} from '../graphql/hooks/use-create-lead-by-thread';
import {notifyUser} from '../helpers';

import {BaseAddLeadButton} from './base-add-lead-button';

interface Props {
    recipientId: string;
    stagesetId: string;
    assigneeId?: string | null;
    threadId: string;
    threadType: ThreadType | null;
}

export function AddLeadFromThreadButton(props: Props) {
    const {createLeadByThread} = useCreateLeadByThread();

    const isEmailThread = props.threadType === ThreadType.EMAIL && props.threadId;

    if (!isEmailThread && isUnidentifiedRecipient(props.recipientId)) {
        return null;
    }

    const handleSubmit = async () => {
        const response = await createLeadByThread({
            threadId: props.threadId,
            stagesetId: props.stagesetId === AUTO_DISTRIBUTE_OPTION.value ? null : props.stagesetId,
            assigneeId: props.assigneeId,
        });
        const createdLead = response?.data?.leadCreateByThread?.lead;
        if (createdLead?.htmlUrlPath) {
            notifyUser(createdLead.htmlUrlPath);
        }
    };

    return <BaseAddLeadButton onSubmit={handleSubmit} />;
}
